import { useTranslation } from "react-i18next";
import { FiArrowRight } from "react-icons/fi";
import "../../styles/CatalogLinkBlock.css";

export default function CatalogLinkBlock({ block, onAction }) {
  const { t } = useTranslation("chat");

  const title = block?.title || t("catalog_title");
  const label = block?.label || t("catalog_open");
  const count = Number(block?.count ?? block?.products_count ?? 0);

  return (
    <div className="catalogLinkBlock">
      {/* <div className="catalogLinkTitle">{title}</div> */}

      <button
        type="button"
        className="catalogListBtn"
        onClick={() => onAction?.({ type: "open_catalog" })}
        aria-label={label}
      >
        <span className="catalogListBtnLabel">{label}</span>

        {count > 0 && (
          <span className="catalogListBtnCount">{count}</span>
        )}

        <FiArrowRight className="catalogListBtnArrow" />
      </button>
    </div>
  );
}